import { Action } from 'redux';
import _ from 'underscore';

import { ISiteNameSansId } from '../../ts/ServerApi/types/ISiteNameSansId';
import { isSiteNamesRequestSucceededAction } from '../actions/spaces/SitesNamesRequestAction';

const InitialState: ReadonlyArray<ISiteNameSansId> = [];

export function sitesReducer(
  previousState: ReadonlyArray<ISiteNameSansId> = InitialState,
  action: Action
): ReadonlyArray<ISiteNameSansId>  {
  if (isSiteNamesRequestSucceededAction(action)) {
    if (action.sites && !_.isEqual(action.sites, previousState)) {
      return action.sites;
    }
  }

  return previousState;
}
